"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[983],{

/***/ 56983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ useUpdatePublicMetadataMutation; },
/* harmony export */   "Ne": function() { return /* binding */ usePublicMetafieldsQuery; },
/* harmony export */   "jI": function() { return /* binding */ useChannelsQuery; },
/* harmony export */   "rk": function() { return /* binding */ useFileUploadMutation; }
/* harmony export */ });
/* unused harmony exports ChannelFragmentDoc, FileUploadErrorFragmentDoc, MetadataErrorFragmentDoc, AddressFragmentDoc, MoneyFragmentDoc, OrderLineFragmentDoc, OrderFragmentDoc, TransactionEventFragmentDoc, TransactionFragmentDoc, TransactionActionPayloadFragmentDoc, WebhookErrorFragmentDoc, AppDocument, useAppQuery, ChannelDocument, useChannelQuery, ChannelsDocument, CheckoutDocument, useCheckoutQuery, FileUploadDocument, PublicMetafieldsDocument, PrivateMetafieldsDocument, usePrivateMetafieldsQuery, PublicMetafieldsInferedDocument, usePublicMetafieldsInferedQuery, PrivateMetafieldsInferedDocument, usePrivateMetafieldsInferedQuery, UpdatePublicMetadataDocument, UpdatePrivateMetadataDocument, useUpdatePrivateMetadataMutation, OrderCreateDocument, useOrderCreateMutation, OrderDetailsDocument, useOrderDetailsQuery, OrderPaymentDetailsDocument, useOrderPaymentDetailsQuery, OrderUpdatePaymentMetafieldDocument, useOrderUpdatePaymentMetafieldMutation, OrderTransactionsDocument, useOrderTransactionsQuery, TransactionCreateDocument, useTransactionCreateMutation, TransactionUpdateDocument, useTransactionUpdateMutation, TransactionProcessedEventsDocument, useTransactionProcessedEventsQuery, TransactionUpdateProcessedEventsDocument, useTransactionUpdateProcessedEventsMutation, TransactionActionRequestSubscriptionDocument, useTransactionActionRequestSubscription, CreateWebhooksDocument, useCreateWebhooksMutation, CheckWebhooksDocument, useCheckWebhooksQuery, MetadataItemFragmentDoc, MetadataFragmentDoc, OrderEventFragmentDoc, FulfillmentFragmentDoc, InvoiceFragmentDoc, OrderErrorFragmentDoc, OrderDetailsFragmentDoc, OrderConfirmDocument, OrderLineUpdateDocument, OrderLineDeleteDocument, OrderCancelDocument */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15771);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28825);
// THIS FILE IS GENERATED WITH `pnpm generate`

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ChannelFragment on Channel {\n    id\n    name\n    slug\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment FileUploadErrorFragment on UploadError {\n    code\n    message\n    field\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment MetadataErrorFragment on MetadataError {\n    code\n    message\n    field\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Address on Address {\n    companyName\n    firstName\n    lastName\n    streetAddress1\n    streetAddress2\n    postalCode\n    city\n    country {\n      code\n    }\n    countryArea\n    phone\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Money on Money {\n    currency\n    amount\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment OrderLine on OrderLine {\n    id\n    productName\n    variantName\n    quantity\n    taxRate\n    variant {\n      id\n      product {\n        id\n        category {\n          name\n        }\n        productType {\n          isDigital\n          kind\n        }\n      }\n    }\n    unitPrice {\n      gross {\n        ...Money\n      }\n    }\n    totalPrice {\n      gross {\n        ...Money\n      }\n      tax {\n        ...Money\n      }\n    }\n    thumbnail {\n      url\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment Order on Order {\n    id\n    number\n    userEmail\n    billingAddress {\n      ...Address\n    }\n    shippingAddress {\n      ...Address\n    }\n    total {\n      gross {\n        ...Money\n      }\n    }\n    discounts {\n      name\n      amount {\n        ...Money\n      }\n    }\n    shippingPrice {\n      gross {\n        ...Money\n      }\n      net {\n        ...Money\n      }\n      tax {\n        ...Money\n      }\n    }\n    shippingTaxRate\n    shippingMethodName\n    deliveryMethod {\n      __typename\n      ... on ShippingMethod {\n        id\n        minimumOrderPrice {\n          ...Money\n        }\n        maximumOrderPrice {\n          ...Money\n        }\n      }\n      ... on Warehouse {\n        id\n        clickAndCollectOption\n      }\n    }\n    privateMetafield(key: "payment")\n    lines {\n      ...OrderLine\n    }\n    status\n  }\n  ',
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TransactionEvent on TransactionEvent {\n    name\n    reference\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Transaction on TransactionItem {\n    id\n    reference\n    voidedAmount {\n      ...Money\n    }\n    refundedAmount {\n      ...Money\n    }\n    chargedAmount {\n      ...Money\n    }\n    authorizedAmount {\n      ...Money\n    }\n    events {\n      ...TransactionEvent\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TransactionActionPayload on TransactionActionRequest {\n    transaction {\n      id\n      reference\n      type\n      authorizedAmount {\n        amount\n        currency\n      }\n      chargedAmount {\n        amount\n      }\n      voidedAmount {\n        amount\n      }\n      refundedAmount {\n        amount\n      }\n    }\n    action {\n      actionType\n      amount\n    }\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment WebhookErrorFragment on WebhookError {\n    message\n    field\n    code\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query App {\n    app {\n      id\n      name\n    }\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Channel($id: ID!) {\n    channel(id: $id) {\n      ...ChannelFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Channels {\n    channels {\n      ...ChannelFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Checkout($id: ID!) {\n    checkout(id: $id) {\n      id\n      totalPrice {\n        gross {\n          amount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation FileUpload($file: Upload!) {\n    fileUpload(file: $file) {\n      uploadedFile {\n        url\n        contentType\n      }\n      errors {\n        ...FileUploadErrorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PublicMetafields($id: ID!, $keys: [String!]) {\n    app(id: $id) {\n      id\n      metafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PrivateMetafields($id: ID!, $keys: [String!]) {\n    app(id: $id) {\n      id\n      privateMetafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PublicMetafieldsInfered($keys: [String!]) {\n    app {\n      id\n      metafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PrivateMetafieldsInfered($keys: [String!]) {\n    app {\n      id\n      privateMetafields(keys: $keys)\n    }\n  }\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdatePublicMetadata($id: ID!, $input: [MetadataInput!]!, $keys: [String!]) {\n    updateMetadata(id: $id, input: $input) {\n      item {\n        metafields(keys: $keys)\n      }\n      errors {\n        ...MetadataErrorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdatePrivateMetadata($id: ID!, $input: [MetadataInput!]!, $keys: [String!]) {\n    updatePrivateMetadata(id: $id, input: $input) {\n      item {\n        privateMetafields(keys: $keys)\n      }\n      errors {\n        ...MetadataErrorFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation OrderCreate($id: ID!) {\n    orderCreateFromCheckout(id: $id) {\n      order {\n        ...Order\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderDetails($id: ID!) {\n    order(id: $id) {\n      ...Order\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query OrderPaymentDetails($id: ID!) {\n    order(id: $id) {\n      authorizeStatus\n      chargeStatus\n      isPaid\n      status\n      privateMetafield(key: "payment")\n    }\n  }\n'
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  mutation OrderUpdatePaymentMetafield($orderId: ID!, $data: String!) {\n    updatePrivateMetadata(id: $orderId, input: { key: "payment", value: $data }) {\n      errors {\n        code\n      }\n    }\n  }\n'
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderTransactions($id: ID!) {\n    order(id: $id) {\n      transactions {\n        ...Transaction\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation TransactionCreate(\n    $id: ID!\n    $transaction: TransactionCreateInput!\n    $transactionEvent: TransactionEventInput\n  ) {\n    transactionCreate(id: $id, transaction: $transaction, transactionEvent: $transactionEvent) {\n      transaction {\n        id\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}
function _templateObject28() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation TransactionUpdate(\n    $id: ID!\n    $transaction: TransactionUpdateInput!\n    $transactionEvent: TransactionEventInput\n  ) {\n    transactionUpdate(id: $id, transaction: $transaction, transactionEvent: $transactionEvent) {\n      transaction {\n        id\n      }\n      errors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject28 = function() {
        return data;
    };
    return data;
}
function _templateObject29() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query TransactionProcessedEvents($id: ID!) {\n    transaction(id: $id) {\n      processedEvents: metafield(key: "processedEvents")\n    }\n  }\n'
    ]);
    _templateObject29 = function() {
        return data;
    };
    return data;
}
function _templateObject30() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  mutation TransactionUpdateProcessedEvents($id: ID!, $input: String!) {\n    updateMetadata(id: $id, input: { key: "processedEvents", value: $input }) {\n      errors {\n        code\n        field\n        message\n      }\n    }\n  }\n'
    ]);
    _templateObject30 = function() {
        return data;
    };
    return data;
}
function _templateObject31() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  subscription TransactionActionRequestSubscription {\n    event {\n      ... on TransactionActionRequest {\n        transaction {\n          id\n          reference\n          type\n          authorizedAmount {\n            amount\n            currency\n          }\n          chargedAmount {\n            amount\n          }\n          voidedAmount {\n            amount\n          }\n          refundedAmount {\n            amount\n          }\n        }\n        action {\n          actionType\n          amount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject31 = function() {
        return data;
    };
    return data;
}
function _templateObject32() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  mutation CreateWebhooks($targetUrl: String, $query: String) {\n    webhookCreate(\n      input: {\n        name: "Checkout app payment notifications"\n        targetUrl: $targetUrl\n        events: [TRANSACTION_ACTION_REQUEST]\n        isActive: true\n        query: $query\n      }\n    ) {\n      errors {\n        ...WebhookErrorFragment\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    _templateObject32 = function() {
        return data;
    };
    return data;
}
function _templateObject33() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query CheckWebhooks {\n    app {\n      webhooks {\n        id\n        targetUrl\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function() {
        return data;
    };
    return data;
}
function _templateObject34() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment MetadataItem on MetadataItem {\n    key\n    value\n  }\n"
    ]);
    _templateObject34 = function() {
        return data;
    };
    return data;
}
function _templateObject35() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Metadata on ObjectWithMetadata {\n    metadata {\n      ...MetadataItem\n    }\n    privateMetadata {\n      ...MetadataItem\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject35 = function() {
        return data;
    };
    return data;
}
function _templateObject36() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment OrderEvent on OrderEvent {\n    id\n    amount\n    shippingCostsIncluded\n    date\n    email\n    emailType\n    invoiceNumber\n    discount {\n      valueType\n      value\n      reason\n      amount {\n        amount\n        currency\n      }\n      oldValueType\n      oldValue\n      oldAmount {\n        amount\n        currency\n      }\n    }\n    relatedOrder {\n      id\n      number\n    }\n    message\n    quantity\n    transactionReference\n    type\n    user {\n      id\n      email\n      firstName\n      lastName\n    }\n    app {\n      id\n      name\n      appUrl\n    }\n    lines {\n      quantity\n      itemName\n      discount {\n        valueType\n        value\n        reason\n        amount {\n          amount\n          currency\n        }\n        oldValueType\n        oldValue\n        oldAmount {\n          amount\n          currency\n        }\n      }\n      orderLine {\n        id\n        productName\n        variantName\n      }\n    }\n  }\n"
    ]);
    _templateObject36 = function() {
        return data;
    };
    return data;
}
function _templateObject37() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Fulfillment on Fulfillment {\n    id\n    lines {\n      id\n      quantity\n      orderLine {\n        ...OrderLine\n      }\n    }\n    fulfillmentOrder\n    status\n    trackingNumber\n    warehouse {\n      id\n      name\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject37 = function() {
        return data;
    };
    return data;
}
function _templateObject38() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment Invoice on Invoice {\n    id\n    number\n    createdAt\n    url\n    status\n  }\n"
    ]);
    _templateObject38 = function() {
        return data;
    };
    return data;
}
function _templateObject39() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment OrderError on OrderError {\n    code\n    field\n    addressType\n    message\n    orderLines\n  }\n"
    ]);
    _templateObject39 = function() {
        return data;
    };
    return data;
}
function _templateObject40() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment OrderDetails on Order {\n    id\n    token\n    ...Metadata\n    billingAddress {\n      ...Address\n    }\n    giftCards {\n      events {\n        id\n        type\n        orderId\n        balance {\n          initialBalance {\n            ...Money\n          }\n          currentBalance {\n            ...Money\n          }\n          oldInitialBalance {\n            ...Money\n          }\n          oldCurrentBalance {\n            ...Money\n          }\n        }\n      }\n    }\n    isShippingRequired\n    canFinalize\n    created\n    customerNote\n    discounts {\n      id\n      type\n      calculationMode: valueType\n      value\n      reason\n      amount {\n        ...Money\n      }\n    }\n    events {\n      ...OrderEvent\n    }\n    fulfillments {\n      ...Fulfillment\n    }\n    lines {\n      ...OrderLine\n    }\n    number\n    isPaid\n    paymentStatus\n    shippingAddress {\n      ...Address\n    }\n    deliveryMethod {\n      __typename\n      ... on ShippingMethod {\n        id\n        minimumOrderPrice {\n          ...Money\n        }\n        maximumOrderPrice {\n          ...Money\n        }\n      }\n      ... on Warehouse {\n        id\n        clickAndCollectOption\n      }\n    }\n    shippingMethod {\n      id\n    }\n    shippingMethodName\n    collectionPointName\n    shippingPrice {\n      gross {\n        amount\n        currency\n      }\n    }\n    status\n    subtotal {\n      gross {\n        ...Money\n      }\n      net {\n        ...Money\n      }\n    }\n    total {\n      gross {\n        ...Money\n      }\n      net {\n        ...Money\n      }\n      tax {\n        ...Money\n      }\n    }\n    actions\n    totalAuthorized {\n      ...Money\n    }\n    totalCaptured {\n      ...Money\n    }\n    totalBalance {\n      ...Money\n    }\n    undiscountedTotal {\n      net {\n        ...Money\n      }\n      gross {\n        ...Money\n      }\n    }\n    user {\n      id\n      email\n    }\n    userEmail\n    shippingMethods {\n      id\n      name\n      price {\n        ...Money\n      }\n      active\n      message\n    }\n    invoices {\n      ...Invoice\n    }\n    channel {\n      isActive\n      id\n      name\n      currencyCode\n      slug\n      defaultCountry {\n        code\n      }\n    }\n    isPaid\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function() {
        return data;
    };
    return data;
}
function _templateObject41() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation OrderConfirm($id: ID!) {\n    orderConfirm(id: $id) {\n      errors {\n        ...OrderError\n      }\n      order {\n        ...OrderDetails\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function() {
        return data;
    };
    return data;
}
function _templateObject42() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation OrderLineUpdate($id: ID!, $input: OrderLineInput!) {\n    orderLineUpdate(id: $id, input: $input) {\n      errors {\n        ...OrderError\n      }\n      orderLine {\n        ...OrderLine\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function() {
        return data;
    };
    return data;
}
function _templateObject43() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation OrderLineDelete($id: ID!) {\n    orderLineDelete(id: $id) {\n      errors {\n        ...OrderError\n      }\n      order {\n        id\n        lines {\n          ...OrderLine\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function() {
        return data;
    };
    return data;
}
function _templateObject44() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation OrderCancel($id: ID!) {\n    orderCancel(id: $id) {\n      errors {\n        ...OrderError\n      }\n      order {\n        ...OrderDetails\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function() {
        return data;
    };
    return data;
}



const ChannelFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
const FileUploadErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
const MetadataErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2());
const AddressFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject3());
const MoneyFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject4());
const OrderLineFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject5(), MoneyFragmentDoc);
const OrderFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject6(), AddressFragmentDoc, MoneyFragmentDoc, OrderLineFragmentDoc);
const TransactionEventFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject7());
const TransactionFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject8(), MoneyFragmentDoc, TransactionEventFragmentDoc);
const TransactionActionPayloadFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject9());
const WebhookErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject10());
const AppDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject11());
function useAppQuery(options) {
    return Urql.useQuery({
        query: AppDocument,
        ...options
    });
}
const ChannelDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject12(), ChannelFragmentDoc);
function useChannelQuery(options) {
    return Urql.useQuery({
        query: ChannelDocument,
        ...options
    });
}
const ChannelsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject13(), ChannelFragmentDoc);
function useChannelsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM({
        query: ChannelsDocument,
        ...options
    });
}
const CheckoutDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject14());
function useCheckoutQuery(options) {
    return Urql.useQuery({
        query: CheckoutDocument,
        ...options
    });
}
const FileUploadDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject15(), FileUploadErrorFragmentDoc);
function useFileUploadMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .Db(FileUploadDocument);
}
const PublicMetafieldsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject16());
function usePublicMetafieldsQuery(options) {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM({
        query: PublicMetafieldsDocument,
        ...options
    });
}
const PrivateMetafieldsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject17());
function usePrivateMetafieldsQuery(options) {
    return Urql.useQuery({
        query: PrivateMetafieldsDocument,
        ...options
    });
}
const PublicMetafieldsInferedDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject18());
function usePublicMetafieldsInferedQuery(options) {
    return Urql.useQuery({
        query: PublicMetafieldsInferedDocument,
        ...options
    });
}
const PrivateMetafieldsInferedDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject19());
function usePrivateMetafieldsInferedQuery(options) {
    return Urql.useQuery({
        query: PrivateMetafieldsInferedDocument,
        ...options
    });
}
const UpdatePublicMetadataDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject20(), MetadataErrorFragmentDoc);
function useUpdatePublicMetadataMutation() {
    return urql__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .Db(UpdatePublicMetadataDocument);
}
const UpdatePrivateMetadataDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject21(), MetadataErrorFragmentDoc);
function useUpdatePrivateMetadataMutation() {
    return Urql.useMutation(UpdatePrivateMetadataDocument);
}
const OrderCreateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject22(), OrderFragmentDoc);
function useOrderCreateMutation() {
    return Urql.useMutation(OrderCreateDocument);
}
const OrderDetailsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject23(), OrderFragmentDoc);
function useOrderDetailsQuery(options) {
    return Urql.useQuery({
        query: OrderDetailsDocument,
        ...options
    });
}
const OrderPaymentDetailsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject24());
function useOrderPaymentDetailsQuery(options) {
    return Urql.useQuery({
        query: OrderPaymentDetailsDocument,
        ...options
    });
}
const OrderUpdatePaymentMetafieldDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject25());
function useOrderUpdatePaymentMetafieldMutation() {
    return Urql.useMutation(OrderUpdatePaymentMetafieldDocument);
}
const OrderTransactionsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject26(), TransactionFragmentDoc);
function useOrderTransactionsQuery(options) {
    return Urql.useQuery({
        query: OrderTransactionsDocument,
        ...options
    });
}
const TransactionCreateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject27());
function useTransactionCreateMutation() {
    return Urql.useMutation(TransactionCreateDocument);
}
const TransactionUpdateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject28());
function useTransactionUpdateMutation() {
    return Urql.useMutation(TransactionUpdateDocument);
}
const TransactionProcessedEventsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject29());
function useTransactionProcessedEventsQuery(options) {
    return Urql.useQuery({
        query: TransactionProcessedEventsDocument,
        ...options
    });
}
const TransactionUpdateProcessedEventsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject30());
function useTransactionUpdateProcessedEventsMutation() {
    return Urql.useMutation(TransactionUpdateProcessedEventsDocument);
}
const TransactionActionRequestSubscriptionDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject31());
function useTransactionActionRequestSubscription() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, handler = arguments.length > 1 ? arguments[1] : void 0;
    return Urql.useSubscription({
        query: TransactionActionRequestSubscriptionDocument,
        ...options
    }, handler);
}
const CreateWebhooksDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject32(), WebhookErrorFragmentDoc);
function useCreateWebhooksMutation() {
    return Urql.useMutation(CreateWebhooksDocument);
}
const CheckWebhooksDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject33());
function useCheckWebhooksQuery(options) {
    return Urql.useQuery({
        query: CheckWebhooksDocument,
        ...options
    });
}
const MetadataItemFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject34());
const MetadataFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject35(), MetadataItemFragmentDoc);
const OrderEventFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject36());
const FulfillmentFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject37(), OrderLineFragmentDoc);
const InvoiceFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject38());
const OrderErrorFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject39());
const OrderDetailsFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject40(), MetadataFragmentDoc, AddressFragmentDoc, MoneyFragmentDoc, OrderEventFragmentDoc, FulfillmentFragmentDoc, OrderLineFragmentDoc, InvoiceFragmentDoc);
const OrderConfirmDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject41(), OrderErrorFragmentDoc, OrderDetailsFragmentDoc);
const OrderLineUpdateDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject42(), OrderErrorFragmentDoc, OrderLineFragmentDoc);
const OrderLineDeleteDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject43(), OrderErrorFragmentDoc, OrderLineFragmentDoc);
const OrderCancelDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject44(), OrderErrorFragmentDoc, OrderDetailsFragmentDoc);


/***/ })

}]);